interface EnvironmentConfig {
  apiBaseUrl: string;
  appVersion: string;
  enablePwa: boolean;
  dynamsoftLicenseKey: string;
}

let config: EnvironmentConfig | null = null;

/**
 * Validates and loads environment variables.
 * Throws an error if any required environment variables are missing.
 * @returns The validated environment configuration
 */
export const validateEnvironment = (): EnvironmentConfig => {
  if (config) {
    return config;
  }

  const apiBaseUrl = import.meta.env.VITE_API_BASE_URL;
  if (!apiBaseUrl) {
    console.error('VITE_API_BASE_URL is required');
    throw new Error('VITE_API_BASE_URL is required');
  }

  const appVersion = import.meta.env.VITE_APP_VERSION || 'unknown';
  const enablePwa = import.meta.env.VITE_ENABLE_PWA === 'true';
  const dynamsoftLicenseKey = import.meta.env.VITE_DYNAMSOFT_LICENSE_KEY || '';

  config = {
    apiBaseUrl,
    appVersion,
    enablePwa,
    dynamsoftLicenseKey,
  };

  console.info('Environment configuration loaded:');
  console.info('API URL:', apiBaseUrl);
  console.info('App Version:', appVersion);
  console.info('Environment:', import.meta.env.MODE);
  console.info('PWA Enabled:', enablePwa);

  return config;
};

export const getEnvironmentConfig = (): EnvironmentConfig => {
  if (!config) {
    throw new Error('Environment not validated. Call validateEnvironment() first.');
  }
  return config;
};
